export default __webpack_public_path__ + "static/media/rasheedat.63a00b2a.png";